import React from "react";
import ReactDOM from "react-dom/client";
import { MainRoute } from "./App";
import { datadogRum } from '@datadog/browser-rum';

import reportWebVitals from "./reportWebVitals";

import { BrowserRouter, Routes, Route } from "react-router-dom";

import TagManager from "react-gtm-module";

datadogRum.init({
  applicationId: '9e15c6f0-3a5c-432c-97a2-7c0f04d229b9',
  clientToken: 'pub7e5c69633ed189e75a4479caecf10edd',
  site: 'datadoghq.com',
  service:'chargeback-api',
  env:'production',
  // Specify a version number to identify the deployed version of your application in Datadog 
  // version: '1.0.0',
  sessionSampleRate: 100,
  sessionReplaySampleRate: 20,
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
  defaultPrivacyLevel:'allow'
});
  
datadogRum.startSessionReplayRecording();

const tagManagerArgs = {
  gtmId: "GTM-KF8M3NK",
};

TagManager.initialize(tagManagerArgs);
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route index element={<MainRoute />}></Route>
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

